var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M7.5 9.5L11.2567 13.6741C11.6539 14.1155 12.3461 14.1155 12.7433 13.6741L16.5 9.5M2.03378 9.61003L11.2474 20.1399C11.6458 20.5952 12.3542 20.5952 12.7526 20.1399L21.9662 9.61003C22.2774 9.25442 22.2972 8.72955 22.0136 8.35153L18.3 3.4C18.1111 3.14819 17.8148 3 17.5 3H6.5C6.18524 3 5.88885 3.14819 5.7 3.4L1.98635 8.35153C1.70284 8.72955 1.72262 9.25442 2.03378 9.61003Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.354e6ec33e7a1e50f945af0fcdba040a.svg";
export { ForwardRef as ReactComponent };